<script>
    import * as campaignService from "./service.js";
    import BreadCrumNav from "../../../components/breadcrum-nav.svelte";
    import V2List from "./_components/v2-list.svelte";
    import { user } from "../../user/user.state.svelte.js";
    import { goto } from "@roxi/routify";
    import { format } from "svelte-i18n";

    console.log(user.data.is_internal)

    if(!user.data.is_internal){
        $goto("/dashboard");
    }

    let campaigns = $state([]);

    let allPromises = $state(
        Promise.all([campaignService.search()])
            .then(([pCampaigns]) => {
                campaigns = pCampaigns;
                return campaigns;
            })
            .catch((e) => {
                return [];
            }),
    );

    const handleTableRefresh = (is_refresh = false) => {
        allPromises = Promise.all([campaignService.search()])
            .then(([pCampaigns]) => {
                campaigns = pCampaigns;
                return campaigns;
            })
            .catch((e) => {
                return [];
            });
    };

    const handleDownloadReport = async (campaignId, lang = "es") => {
        try {
            await campaignService.downloadReportFile({ id: campaignId }, lang);
        } catch (error) {
            console.error("Error downloading report:", error);
        }
    };
</script>

<section class="content-header">
    <div class="container-fluid">
        <div class="row">
            <div class="col-6">
                <h1 class="mt-3 mb-3 page-title">
                    <i class="fas fa-fish fa-xs"></i>
                    {$format("phishing.campaign.plural")}
                </h1>
            </div>
            <div class="col-6">
                <BreadCrumNav
                    routes={[{ label: $format("phishing.campaign.plural") }]}
                />
            </div>
        </div>
    </div>
</section>

<section class="content">
    <div class="container-fluid">
        {#await allPromises then data}
            <V2List
                {data}
                onadd={handleTableRefresh}
                ondel={handleTableRefresh}
                onedit={handleTableRefresh}
                ontableRefresh={() => handleTableRefresh(true)}
                ondownload={handleDownloadReport}
            />
        {/await}
        {#await allPromises}
            <div class="overlay">
                <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
        {/await}
    </div>
</section>

<style>
</style>
